import { encrypt } from '@/common/securityUtils';
import { useCan } from '@/components/can/Can';
import { PERMS } from '@/features/auth/permissions/permissionKeys';
import { defaultMeta } from '@/constants/defaultMeta';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { referralReportQueries } from '@/services/dashboard/referralReports/referralReports.queries';
import { ReferralUserType } from '@/services/dashboard/referralReports/referralReports.types';
import { useSearch } from '@tanstack/react-router';

export const useAffiliateReferralReport = () => {
  const canReadReport = useCan({ allOf: [PERMS.affiliate.referral.report.view] });
  const { q, createdDate, page, fetch, sort, userType } = useSearch({
    from: '/(app)/dashboard/referral-reports/',
  });
  const dateRange = parseDateRangeSearch(Array.isArray(createdDate) ? createdDate.join(',') : createdDate);
  const { data, isLoading } = useQuery({
    ...referralReportQueries.affiliateList({
      search: q,
      fromDate: dateRange.start,
      toDate: dateRange.end,
      agentType: encrypt('6'),
      row: page,
      fetch,
    }),
    select: (response) => ({
      ...response,
      data: sortBy(response.data ?? [], sort, {
        createdDate: 'actionDate',
        updatedDate: 'actionDate',
      }),
    }),
    enabled: userType === ReferralUserType.Affiliate && canReadReport,
  });

  return {
    affiliateReferralReports: data?.data ?? [],
    isLoading,
    pagination: data?.meta?.pagination ?? defaultMeta,
  };
};
